import React from "react";
import Box from "@amzn/meridian/box";
import Theme from "@amzn/meridian/theme";
import Text from "@amzn/meridian/text";

import { ReturnOrderCountList, StatusToken } from "../styles/Style";
import { IStatusProviderProps } from "../types/StatusProvider.type";

export const StatusProvider = ({
  returnStatus,
  width = '100%',
  padding = 'none'
}: IStatusProviderProps) => {
  const currentState = ReturnOrderCountList.filter(
    (list) => list.id === returnStatus,
  );
  if (!currentState) return null;
  return (
    <Theme
      tokens={StatusToken(
        currentState[0]?.textColor,
        currentState[0]?.backgroundColor,
      )}
      data-testid="statusprovider-status-theme"
    >
      <Box
        spacingInset={padding}
        type="fill"
        width={width}
        data-testid="statusprovider-status-box"
      >
        <Text type="b200" alignment="center" data-testid="statusprovider-status-text">
          {currentState[0]?.title}
        </Text>
      </Box>
    </Theme>
  );
};